import actions from 'redux/actions'
import { getState, reducers } from 'redux/core'
import { getGenderByPathname, constants } from 'common/helpers'
import request from 'sb-request'


const updateActiveFiltersInCookies = () => {
  clearTimeout(updateActiveFiltersInCookies.timeout)
  // TODO hack to get latest state
  updateActiveFiltersInCookies.timeout = setTimeout(() => {
    const { view: { smartSearchPage: { activeFilters } } } = getState()

    actions.misc.cookies.setItem(constants.cookieNames.activeFilters, activeFilters)
  }, 0)
}

const fetchBrands = (gender) =>
  actions.models.brands.fetch(gender)
    .then((brands) => brands.map(({ name, count }) => ({
      label: name,
      value: name,
      count,
    })))
    .then((brands) => reducers.view.smartSearchPage.setBrands(brands))

const fetchNotes = (gender) => {
  const countParam = gender === 'female' ? 'perfumesCount' : 'colognesCount'

  return request.post('graphql?name=notes', {
    body: {
      query: `{
        notes(active: true, gender: "${gender}", published: true) {
          id
          name
          perfumesCount
          count: ${countParam}
        }
      }`,
    },
    modifyResult: ({ notes }) => notes.map((item) => ({ ...item, label: item.name, value: item.name })),
    multiple: true,
  })
    .then(reducers.view.smartSearchPage.setNotes)
}

const fetchTags = (gender) =>
  request.post('graphql?name=filterTags', {
    body: {
      query: `{
        filterTags {
          ${gender} {
            id,
            name,
            img,
            type,
            productsCount
          }
        }
      }`,
    },
    multiple: true,
  })
    .then(({ filterTags = {} }) => {
      let tags = filterTags[gender]

      if (tags && tags.length) {
        tags = tags.map((item) => ({ ...item, label: item.name, value: item.id }))
      }

      if (gender === 'male') {
        reducers.view.smartSearchPage.setTagsMale(tags)
      }
      else {
        reducers.view.smartSearchPage.setTagsFemale(tags)
      }
    })

const fetchTypes = (gender) =>
  request.post('graphql?name=productTypes', {
    body: {
      query: `{
        productTypes(kind: "Perfume") {
          id
          name
        }
      }`,
    },
    modifyResult: ({ productTypes }) => productTypes.map((item) => ({ label: item.name, value: item.id })),
    // mock: true,
    // mockData: {
    //   productTypes: [
    //     { id: 'EauDeToilette', name: 'Eau de Toilette' },
    //     { id: 'EauDeParfum', name: 'Eau de Parfum' },
    //     { id: 'EauDeCologne', name: 'Eau de Cologne' },
    //     { id: 'ParfumOil', name: 'Parfum Oil' },
    //     { id: 'BlendedEssence', name: 'Blended Essence' },
    //     { id: 'ExtraitDeParfum', name: 'Extrait de Parfum' },
    //   ],
    // },
    multiple: true,
  })
    .then(reducers.view.smartSearchPage.setTypes)

/**
 *
 */
const fetchFragrances = (filters = {}) => {
  // TODO hack to get latest state
  setTimeout(() => {
    const state = getState()

    const { view: { smartSearchPage: { activeFilters } } } = state

    const gender = activeFilters.gender || getGenderByPathname(state)

    reducers.view.smartSearchPage.setFetching(true)

    return actions.models.fragrances.fetch({ ...activeFilters, gender, ...filters })
      .then((items) => {
        reducers.view.smartSearchPage.setFragrances(items)
        return items
      })
  }, 0)
}

/**
 *
 * @param filters
 * @param filters.gender {String}
 */
const getFragrancesCount = (filters = {}) => {
  const state = getState()

  const { view: { smartSearchPage: { activeFilters } } } = state

  return actions.models.fragrances.getCount({ ...activeFilters, ...filters })
}

// for except mobile
const openTagsOverlay = () => reducers.view.smartSearchPage.setTagsOverlayVisibility(true)
const closeTagsOverlay = () => reducers.view.smartSearchPage.setTagsOverlayVisibility(false)

// for mobiles only
const openFiltersOverlay = (initialActiveFilter = null) => {
  reducers.view.smartSearchPage.setFiltersOverlayInitialFilter(initialActiveFilter)
  reducers.view.smartSearchPage.setFiltersOverlayVisibility(true)
}

const closeFiltersOverlay = () => {
  reducers.view.smartSearchPage.setFiltersOverlayVisibility(false)
  reducers.view.smartSearchPage.setFiltersOverlayInitialFilter(null)
}

const resetFiltersOverlayInitialFilter = () =>
  reducers.view.smartSearchPage.setFiltersOverlayInitialFilter(null)

/**
 * Action to remove unused filters from activeFilters based on saved cookies
 * Flow: user select filters. Some of those filters will be disabled in admin.
 * Then user loads page again - we need remove disabled filters from his activeFilters list.
 */
const removeDisabledFilters = () => {
  const { view: { smartSearchPage: { activeFilters, filters } } } = getState()
  const filterKeys = ['notes', 'brands']

  filterKeys.forEach((key) => {
    const activeFilterValues = activeFilters[key]
    const filterValues = filters[key]

    if (activeFilterValues.length && filterValues.length) {
      activeFilterValues.forEach((activeFilterValue) => {
        const isFilterExists = filterValues.some((item) => item.value === activeFilterValue)

        if (!isFilterExists) {
          reducers.view.smartSearchPage.toggleActiveFilter({
            activeFilter: key,
            value: activeFilterValue,
          })
        }
      })
    }
  })

  updateActiveFiltersInCookies()
}

/**
 *
 * @param {String} category
 */
const setActiveCategory = (category) => {
  const { view: { smartSearchPage: { activeFilters: { category: activeCategory } } } } = getState()

  if (category !== activeCategory) {
    reducers.view.smartSearchPage.setActiveCategory(category)
    updateActiveFiltersInCookies()
  }
}

/**
 *
 * @param {Number} rating
 */
const setActiveRating = (rating) => {
  const { view: { smartSearchPage: { activeFilters: { rating: activeRating } } } } = getState()

  reducers.view.smartSearchPage.setActiveRating(rating !== activeRating ? rating : 0)
  updateActiveFiltersInCookies()
}

/**
 *
 * @param {String} gender
 */
const setActiveGender = (gender) => {
  reducers.view.smartSearchPage.setActiveGender(gender)
  // After changing gender we need to reload all things, so reset isFetched
  reducers.view.smartSearchPage.setFetched(false)
  updateActiveFiltersInCookies()
}

/**
 *
 * @param {String} name
 */
const toggleActiveBrand = (name) => {
  reducers.view.smartSearchPage.toggleActiveBrand(name)
  updateActiveFiltersInCookies()
}

/**
 *
 * @param {String} name
 */
const toggleActiveNote = (name) => {
  reducers.view.smartSearchPage.toggleActiveNote(name)
  updateActiveFiltersInCookies()
}

/**
 *
 * @param {String} name
 */
const toggleActiveType = (name) => {
  reducers.view.smartSearchPage.toggleActiveType(name)
  updateActiveFiltersInCookies()
}

/**
 *
 * @param {Number} tagId
 */
const toggleActiveTag = (tagId) => {
  reducers.view.smartSearchPage.toggleActiveTag(tagId)
  updateActiveFiltersInCookies()
}

const clearTagFilters = () => {
  reducers.view.smartSearchPage.clearTagFilters()
  updateActiveFiltersInCookies()
}

const clearBrandFilters = () => {
  reducers.view.smartSearchPage.clearBrandFilters([])
  updateActiveFiltersInCookies()
}

const clearFilters = () => {
  reducers.view.smartSearchPage.clearFilters()
  updateActiveFiltersInCookies()
}


export default {
  openTagsOverlay,
  closeTagsOverlay,
  openFiltersOverlay,
  closeFiltersOverlay,

  fetchBrands,
  fetchNotes,
  fetchTags,
  fetchFragrances,
  fetchTypes,

  setActiveCategory,
  setActiveRating,
  setActiveGender,

  toggleActiveBrand,
  toggleActiveNote,
  toggleActiveTag,
  toggleActiveType,

  clearTagFilters,
  clearBrandFilters,
  clearFilters,

  getFragrancesCount,
  removeDisabledFilters,
  resetFiltersOverlayInitialFilter,
}
